<template>
  <v-container fluid class="pa-0">
    <template>
      <div class="frota-dropdown-menu">
        <v-toolbar
            color="white"
            flat
            dense
            elevation="1"
            class="toolbar-menu"
            height="58"
            rounded
        >
          <!-- Título do módulo -->
          <v-toolbar-title class="d-flex align-center">
            <v-icon color="primary" class="mx-2">mdi-truck-outline</v-icon>
            <span class="text-h6 font-weight-bold primary--text">Gestão de Frota</span>
          </v-toolbar-title>

          <v-divider vertical class="mx-4"></v-divider>

          <!-- Menus dropdown -->
          <div class="d-flex align-center">
            <v-menu
                v-for="(menu, index) in menus"
                :key="menu.label"
                offset-y
                :close-on-content-click="false"
                transition="slide-y-transition"
                :nudge-bottom="8"
                max-height="400"
                ref="mainMenus"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                    text
                    v-bind="attrs"
                    v-on="on"
                    class="menu-button mx-1"
                    :class="{ 'menu-active': activeMenu === index }"
                    @mouseenter="activeMenu = index"
                    @mouseleave="activeMenu = null"
                >
                  <span class="menu-emoji mr-2">{{ menu.icon }}</span>
                  <span class="menu-text">{{ menu.label }}</span>
                  <v-icon right size="18" class="ml-1">mdi-chevron-down</v-icon>
                </v-btn>
              </template>

              <!-- Conteúdo do dropdown -->
              <v-card class="menu-dropdown" elevation="8">
                <v-card-title class="pa-3 menu-header" :class="getMenuHeaderClass(menu.label)">
                  <span class="mr-2">{{ menu.icon }}</span>
                  {{ menu.label }}
                </v-card-title>

                <v-list class="pa-0" dense>
                  <template v-for="item in getSubMenuItems(menu.label)">
                    <!-- Item com submenu -->
                    <div v-if="item.submenus" :key="item.title">
                      <v-menu
                          offset-x
                          :close-on-content-click="true"
                          transition="slide-x-transition"
                          :nudge-right="8"
                          max-height="300"
                          ref="subMenus"
                      >
                        <template v-slot:activator="{ on: onSubmenu, attrs: attrsSubmenu }">
                          <v-list-item
                              v-bind="attrsSubmenu"
                              v-on="onSubmenu"
                              class="menu-item submenu-trigger"
                              :class="{ 'menu-item-active': isSubmenuActive(item.submenus) }"
                          >
                            <v-list-item-icon class="mr-3">
                              <v-avatar :color="item.color" size="26">
                                <v-icon color="white" size="16">{{ item.icon }}</v-icon>
                              </v-avatar>
                            </v-list-item-icon>

                            <v-list-item-content>
                              <v-list-item-title class="font-weight-medium">
                                {{ item.title }}
                              </v-list-item-title>
                            </v-list-item-content>

                            <v-list-item-action>
                              <v-icon size="16" color="grey">
                                mdi-chevron-right
                              </v-icon>
                            </v-list-item-action>
                          </v-list-item>
                        </template>

                        <!-- Submenu dropdown -->
                        <v-card class="submenu-dropdown" elevation="6">
                          <v-list class="pa-0" dense>
                            <v-list-item
                                v-for="subitem in item.submenus"
                                :key="subitem.title"
                                @click="navigateToSubmenu(subitem.route)"
                                class="submenu-item"
                                :class="{ 'submenu-item-active': $route.path === subitem.route }"
                            >
                              <v-list-item-icon class="mr-3">
                                <v-avatar :color="subitem.color" size="28">
                                  <v-icon color="white" size="18">{{ subitem.icon }}</v-icon>
                                </v-avatar>
                              </v-list-item-icon>

                              <v-list-item-content>
                                <v-list-item-title class="font-weight-medium">
                                  {{ subitem.title }}
                                </v-list-item-title>
                              </v-list-item-content>

                              <v-list-item-action>
                                <v-icon
                                    size="16"
                                    :color="$route.path === subitem.route ? 'primary' : 'grey'"
                                >
                                  mdi-chevron-right
                                </v-icon>
                              </v-list-item-action>
                            </v-list-item>
                          </v-list>
                        </v-card>
                      </v-menu>
                    </div>

                    <!-- Item sem submenu -->
                    <v-list-item
                        v-else
                        :key="item.title"
                        @click="navigateTo(item.route, true)"
                        class="menu-item"
                        :class="{ 'menu-item-active': $route.path === item.route }"
                    >
                      <v-list-item-icon class="mr-3">
                        <v-avatar :color="item.color" size="26">
                          <v-icon color="white" size="16">{{ item.icon }}</v-icon>
                        </v-avatar>
                      </v-list-item-icon>

                      <v-list-item-content>
                        <v-list-item-title class="font-weight-medium">
                          {{ item.title }}
                        </v-list-item-title>
                      </v-list-item-content>

                      <v-list-item-action>
                        <v-icon
                            size="16"
                            :color="$route.path === item.route ? 'primary' : 'grey'"
                        >
                          mdi-chevron-right
                        </v-icon>
                      </v-list-item-action>
                    </v-list-item>
                  </template>
                </v-list>
              </v-card>
            </v-menu>
          </div>

          <v-spacer></v-spacer>

          <!-- Indicador de rota atual -->
          <v-chip
              v-if="currentPageInfo"
              :color="currentPageInfo.color"
              text-color="white"
              small
              class="mr-2 d-none d-md-inline"
          >
            <v-icon left size="16">{{ currentPageInfo.icon }}</v-icon>
            {{ currentPageInfo.title }}
          </v-chip>
        </v-toolbar>

        <!-- Área de conteúdo -->
        <v-main class="content-main pt-4">
          <transition name="page-fade" mode="out-in">
            <router-view />
          </transition>
        </v-main>
      </div>
    </template>
  </v-container>
</template>

<script>
import {mapState} from "vuex";
import axios from "axios";
import mixinFilial from "../../util/mixinFilial";

export default {
  mixins: [mixinFilial],
  data() {
    return {
      activeMenu: null,

      produtos: [],
      veiculos: [],
      busca: {
        idfilial: null,
        idproduto: null,
        idveiculo: null
      },

      menus: [
        { label: 'ANÁLISES', icon: '📊' },
        { label: 'CADASTROS', icon: '📝' },
        { label: 'FINANCEIRO', icon: '💰' },
      ],
      analises: [
        { title: 'Dashboard', icon: 'mdi-chart-box-outline', color: 'red darken-4', route: '/gestao-frota/dashboard' },
        // { title: 'Gestão Visual', icon: 'mdi-eye-outline', color: 'green darken-3', route: '/gestao-frota/gestao-visual' },
        { title: 'Relatórios', icon: 'mdi-file-chart-outline', color: 'blue darken-3', route: '/gestao-frota/relatorios' },
      ],
      cadastros: [
        { title: 'Veículos', icon: 'mdi-truck', color: 'blue-grey darken-2', route: '/gestao-frota/cadastros/veiculos' },
        // { title: 'Fornecedores', icon: 'mdi-domain', color: 'deep-orange darken-2', route: '/gestao-frota/fornecedores' },
        // { title: 'Motoristas', icon: 'mdi-account', color: 'lime darken-3', route: '/gestao-frota/motoristas' },
      ],
      financeiro: [
        {
          title: 'Abastecimentos',
          icon: 'mdi-gas-station',
          color: 'green darken-2',
          submenus: [
            {
              title: 'Requisições',
              icon: 'mdi-file-document-outline',
              color: 'green darken-2',
              route: '/gestao-frota/financeiro/abastecimentos/requisicoes'
            },
            {
              title: 'Despesas',
              icon: 'mdi-currency-usd',
              color: 'green darken-2',
              route: '/gestao-frota/financeiro/abastecimentos/despesas'
            }
          ]
        },
        // { title: 'Pneus', icon: 'mdi-tire', color: 'brown darken-2', route: '/gestao-frota/pneus' },
        // { title: 'Peças', icon: 'mdi-cog-outline', color: 'orange darken-3', route: '/gestao-frota/pecas' },
        // { title: 'Serviços', icon: 'mdi-wrench-outline', color: 'red darken-3', route: '/gestao-frota/servicos' },
        // { title: 'Outros', icon: 'mdi-currency-usd', color: 'brown darken-2', route: '/gestao-frota/outros' },
      ],

      carregando:false,
    };
  },
  computed: {
    ...mapState(["backendUrl", "pgLimit", "usuario"]),
    filiaisFiltro() {
      if (this.filiais.lista) {
        return this.filiais.lista.filter((v) => {
          return (
              v.idfilial !== 6 &&
              v.idfilial !== 12 &&
              v.idfilial !== 25 &&
              v.idfilial !== 29 &&
              v.idfilial !== 33 &&
              v.idfilial !== 37
          );
        });
      } else {
        return [];
      }
    },
    currentPageInfo() {
      const currentPage = this.getAllMenuItems().find(item => item.route === this.$route.path)
      return currentPage || null
    },
  },
  methods: {
    getSubMenuItems(menuLabel) {
      switch (menuLabel) {
        case 'ANÁLISES':
          return this.analises
        case 'CADASTROS':
          return this.cadastros
        case 'FINANCEIRO':
          return this.financeiro
        default:
          return []
      }
    },

    getAllMenuItems() {
      let allItems = [...this.analises, ...this.cadastros]

      // Adicionar itens do financeiro, incluindo submenus
      this.financeiro.forEach(item => {
        if (item.submenus) {
          allItems = [...allItems, ...item.submenus]
        } else {
          allItems.push(item)
        }
      })

      return allItems
    },

    isSubmenuActive(submenus) {
      return submenus.some(submenu => this.$route.path === submenu.route)
    },

    getMenuHeaderClass(menuLabel) {
      switch (menuLabel) {
        case 'ANÁLISES':
          return 'red darken-4 white--text'
        case 'CADASTROS':
          return 'blue-grey darken-2 white--text'
        case 'FINANCEIRO':
          return 'green darken-2 white--text'
        default:
          return 'grey darken-2 white--text'
      }
    },

    navigateTo(route, fechaMenu = true) {
      if (this.$route.path !== route) {
        this.$router.push(route)

        if (fechaMenu) {
          this.closeAllMenus()
        }
      }
    },

    // Novo método específico para navegação de submenus
    navigateToSubmenu(route) {
      if (this.$route.path !== route) {
        this.$router.push(route)
        // Sempre fecha todos os menus ao navegar via submenu
        this.closeAllMenus()
      }
    },

    // Método melhorado para fechar todos os menus
    closeAllMenus() {
      // Fecha menus principais
      if (this.$refs.mainMenus) {
        this.$refs.mainMenus.forEach(menu => {
          if (menu && menu.isActive) {
            menu.isActive = false
          }
        })
      }

      // Fecha submenus
      if (this.$refs.subMenus) {
        this.$refs.subMenus.forEach(submenu => {
          if (submenu && submenu.isActive) {
            submenu.isActive = false
          }
        })
      }

      // Método alternativo usando DOM (fallback)
      this.$nextTick(() => {
        const activeMenus = document.querySelectorAll('.v-menu__content')
        activeMenus.forEach(menu => {
          menu.style.display = 'none'
        })
      })
    },

    listarProdutos() {
      return axios
          .post(`${this.backendUrl}tms/produto/listar`, {
            limit: 9999,
            offset: 0,
            busca: null,
          })
          .then((res) => {
            if (res.data != null) {
              this.produtos = res.data;
            }
          });
    },
    listarVeiculos() {
      return axios
          .post(`${this.backendUrl}tms/veiculo/listar`, {
            limit: 9999,
            offset: 0,
            busca: null,
          })
          .then((res) => {
            if (res.data != null) {
              this.veiculos = res.data;
            }
          });
    },
    async init(){
      await this.listarVeiculos();
      await this.listarProdutos();
    }
  },
  created() {
    this.busca.idfilial = this.usuario.idfilial;
    this.init();
  }
};
</script>

<style scoped>
.frota-dropdown-menu {
  width: 100%;
}

.toolbar-menu {
  border-bottom: 1px solid #e0e0e0;
}

.menu-button {
  text-transform: none !important;
  letter-spacing: normal !important;
  font-size: 0.875rem !important;
  padding: 8px 12px !important;
  border-radius: 6px !important;
  transition: all 0.2s ease !important;
}

.menu-button:hover {
  background-color: rgba(25, 118, 210, 0.08) !important;
}

.menu-active {
  background-color: rgba(25, 118, 210, 0.12) !important;
  color: #023449 !important;
}

.menu-emoji {
  font-size: 16px;
}

.menu-text {
  font-weight: 500;
}

.menu-dropdown {
  border-radius: 8px !important;
  overflow: hidden;
  min-width: 200px;
}

.menu-header {
  font-size: 0.875rem !important;
  font-weight: 600 !important;
}

.menu-item {
  transition: all 0.2s ease;
  border-radius: 0 !important;
}

.menu-item:hover {
  background-color: rgba(0, 0, 0, 0.04) !important;
}

.menu-item-active {
  background-color: rgba(25, 105, 210, 0.08) !important;
  border-left: 3px solid #03124e;
}

.submenu-trigger:hover {
  background-color: rgba(76, 175, 80, 0.08) !important;
}

.submenu-dropdown {
  border-radius: 6px !important;
  overflow: hidden;
  min-width: 180px;
}

.submenu-item {
  transition: all 0.2s ease;
  border-radius: 0 !important;
  padding: 8px 12px !important;
}

.submenu-item:hover {
  background-color: rgba(76, 175, 80, 0.08) !important;
}

.submenu-item-active {
  background-color: rgba(99, 210, 25, 0.08) !important;
  border-left: 3px solid #194e03;
}

.content-main {
  background-color: #fafafa;
}

/* Transições de página */
.page-fade-enter-active,
.page-fade-leave-active {
  transition: opacity 0.3s ease;
}

.page-fade-enter,
.page-fade-leave-to {
  opacity: 0;
}

/* Responsividade */
@media (max-width: 960px) {
  .menu-text {
    display: none;
  }

  .menu-emoji {
    margin-right: 0 !important;
  }
}

@media (max-width: 600px) {
  .v-toolbar-title span {
    font-size: 1rem !important;
  }
}
</style>